
import React, { useState } from 'react'
import { Container, Header, Icon, Menu, Grid, Image, Label, Rail, Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import ReactBnbGallery from 'react-bnb-gallery';
import VisibilitySensor from "react-visibility-sensor"


const Section1 = ({ visibilyChange }) => {

    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const PHOTOS = ['https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp', 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp'];

    return (
        <VisibilitySensor partialVisibility={true} onChange={visibilyChange}>
            <Container className="bg-white" id="property-section1">
                <Header as='h2'>خانه تعطیلات ضد کرونا منحصر به فرد روی آب!</Header>
                <Menu secondary className="align-items-center">
                    <Label basic className="border-none">
                        <Icon className="m-0 m-4px-b" name='star' color="red" />
                        4.95
                    </Label>
                    .
                    <Label basic as='a' className="border-none">
                        <span className="p-4px-r p-4px-l">20</span>
                        {t("property:Reviews")}
                    </Label>
                    <Menu.Menu position='right'>
                        <Label as="a" basic className="border-none">
                            <Icon className="m-0" name='share square outline' /> {t("property:Share")}
                        </Label>
                        <Label as="a" basic className="border-none">
                            <Icon className="m-0" name='heart outline' /> {t("property:Save")}
                        </Label>

                    </Menu.Menu>
                </Menu>

                <Grid columns={3} className="h-min-350">
                    <Grid.Row stretched>
                        <Grid.Column width={8} className="p-4px-l p-0-r">

                            <Image className='m-4px-b rounded-right-30' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp' />
                            <Button color="black" className="position-absolute bottom-4 right-4" onClick={() => setIsOpen(true)}>
                                <Icon name="th" />
                                {t("property:ShowAllPhotos")}

                            </Button>
                        </Grid.Column >
                        <Grid.Column width={4} className="p-4px-l p-0-r">
                            <Image className='m-4px-b' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp' />
                            <Image className='m-4px-b' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp' />
                        </Grid.Column>
                        <Grid.Column width={4} className="p-4px-l p-0-r">
                            <Image className='m-4px-b rounded-left-top-30' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/090d499223d678fa9fc3158ce52f2f65-full.webp' />
                            <Image className='m-4px-b rounded-left-bottom-30' src='https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp' />
                        </Grid.Column>
                    </Grid.Row>

                    <ReactBnbGallery
                        show={isOpen}
                        photos={PHOTOS}
                        onClose={() => setIsOpen(false)}
                    />
                </Grid>
            </Container>
        </VisibilitySensor>

    )
}
export default Section1